import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { realtime } from "../store";
import { enriquecerArticulos, textoPorDeposito } from "../../shared/stock.js";

const TABLA = "stock";

// Lo último que llegó de la tabla y a quién avisarle, para volver a armar
// «porDeposito» cuando cambian los depósitos (pueden llegar después).
let ultimoStock = null;
let ultimoCallback = null;

const enriquecer = (stock) =>
  enriquecerArticulos(stock, realtime.proveedores || []).map((a) => ({
    ...a,
    porDeposito: textoPorDeposito(a.id, realtime.depositos || []),
  }));

export const subscribeStock = (callback) => {
  ultimoCallback = callback;
  return subscribeTable(TABLA, (stock) => {
    ultimoStock = stock;
    callback(enriquecer(stock));
  });
};

export const reenriquecerStock = () => {
  if (ultimoStock && ultimoCallback) ultimoCallback(enriquecer(ultimoStock));
};

// Metodos
export const createStock = ({ id, ...data }) => createRow(TABLA, id, data);
export const updateStock = (id, data) => updateRow(TABLA, id, data);
export const deleteStock = (id) => deleteRow(TABLA, id);
